<template>
  <div class="p-4 container-fluid form-new-raffle card card-body">
    <div class="d-flex justify-content-between align-items-center w-100 mb-4">
      <h4 class="new-campaign-title mb-0 d-flex align-items-center gap-2">
        <i class="material-icons ticket-icon">confirmation_number</i>
        {{ pageTitle }}
      </h4>
    </div>

    <div v-if="user && (!!user.system_wallet || isPlanActive) && pageTitle === 'Nova campanha'" 
      class="rounded p-3 mb-4 d-flex shadow-sm align-items-center"
      :class="{ 
        'bg-gradient-warning text-white': !!user.system_wallet,
        'bg-premium-diamond': !user.system_wallet && isLifetime,
        'bg-gradient-info text-white': !user.system_wallet && isPlanActive && !isLifetime 
      }"
    >
      <i class="material-icons me-2" 
         :class="{ 'text-white': !!user.system_wallet || !isLifetime, 'text-gold': !user.system_wallet && isLifetime }"
         style="font-size: 28px;">
        {{ !!user.system_wallet ? 'info' : (isLifetime ? 'diamond' : 'star') }}
      </i>
      <span class="text-sm font-weight-bold" style="line-height: 1.4;">
        <template v-if="!!user.system_wallet">
          Atenção! Como você utiliza a Carteira do Sistema, as campanhas são criadas gratuitamente. Campanhas vazias (sem nenhum participante pago) e criadas há mais de 7 dias são automaticamente excluídas para evitar sobrecarga. Mantenha sua campanha movimentada!
        </template>
        <template v-else-if="isLifetime">
          <span class="premium-text">Destaque Diamond:</span> Parabéns! Como nosso parceiro <span class="premium-text-gold">VITALÍCIO</span>, você tem isenção total em taxas de publicação e acesso a todos os recursos premium para sempre.
        </template>
        <template v-else-if="isPlanActive">
          Parabéns! Como você possui um Plano <span class="fw-bolder">STARTER</span> ativo, suas campanhas são isentas de taxa de publicação. Aproveite os benefícios da sua assinatura mensal!
        </template>
      </span>
    </div>

    <form class="campaing-form">
      <DefaultInput
        v-model="newRaffleForm.name"
        label="Título da campanha *"
        placeholder="Insira o título de sua campanha"
      />

      <div class="input-group input-group-outline m-0 d-flex flex-column">
        <label class="input-label">
          <span class="text-xs text-uppercase text-body font-weight-bolder"
            >Modelo *</span
          >
          <select
            class="form-control default-bordered-input"
            v-model="newRaffleForm.type"
          >
            <option value="AUTO">
              Sistema escolhe as cotas aleatóriamente
            </option>
            <option value="MANUAL" v-if="newRaffleForm.qnt_quotas <= 3000">
              Cliente escolhe as cotas manualmente
            </option>
          </select>
        </label>
      </div>

      <div>
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
          <span class="text-xs text-uppercase text-body font-weight-bolder mb-0">
            Descrição / Regulamento
          </span>
          <span class="badge bg-gradient-primary text-white mb-0" style="font-size: 0.65rem">
            IA · Legenda automática
          </span>
        </div>

        <div class="card border mb-3 p-3 ai-caption-box">
          <label class="form-label font-weight-bold text-dark text-sm mb-1">
            Conte pra IA o que é a sua rifa
          </label>
          <p class="text-xs text-secondary mb-2 mb-md-3">
            Ex.: bicicleta elétrica, cota R$ 0,02, poucos números, tem cota premiada.
            A IA monta uma legenda personalizada de ação entre amigos.
          </p>
          <textarea
            v-model="aiCaptionBrief"
            class="form-control border ai-caption-input"
            rows="4"
            maxlength="1200"
            placeholder="Ex.: Ação entre amigos de uma bicicleta elétrica. Cota a R$ 0,02. Poucos números. Tem cota premiada."
          ></textarea>
          <div class="ai-caption-actions d-flex flex-wrap align-items-center gap-2 mt-3">
            <button
              type="button"
              class="btn bg-gradient-primary mb-0 ai-caption-btn"
              :disabled="generatingCaption || !aiCaptionBrief.trim()"
              @click="generateAiCaption"
            >
              <i class="material-icons text-sm me-1" style="vertical-align: middle">auto_awesome</i>
              {{ generatingCaption ? 'Gerando...' : 'Gerar legenda com IA' }}
            </button>
            <span v-if="aiCaptionHint" class="text-xs text-secondary ai-caption-hint">{{ aiCaptionHint }}</span>
          </div>
        </div>

        <Editor
          :key="editorKey"
          :model-value="newRaffleForm.description"
          v-model="newRaffleForm.description"
          editorStyle="height: 320px"
          class="default-bordered-input"
        >
          <template #toolbar>
            <span class="ql-formats">
              <select class="ql-header">
                <option selected></option>
                <option value="1">Título 1</option>
                <option value="2">Título 2</option>
                <option value="3">Título 3</option>
              </select>
            </span>
            <span class="ql-formats">
              <select class="ql-font"></select>
            </span>
            <span class="ql-formats">
              <button class="ql-align" value="right"></button>
              <button class="ql-align" value="center"></button>
              <button class="ql-align" value=""></button>
              <button class="ql-align" value="justify"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <button class="ql-strike"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-link"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-clean"></button>
            </span>
          </template>
        </Editor>
      </div>

      <div>
        <div class="card border mb-3 p-3">
          <label class="form-label font-weight-bold text-dark text-sm mb-1">
            Vídeo do YouTube (opcional)
          </label>
          <p class="text-xs text-secondary mb-2">
            Se preenchido, o vídeo aparece primeiro no carrossel da página da
            campanha, antes das imagens.
          </p>
          <div class="input-group input-group-outline w-100 is-filled">
            <label class="form-label">Link do YouTube</label>
            <input
              type="url"
              class="form-control"
              v-model="newRaffleForm.gallery_youtube_url"
              placeholder="https://www.youtube.com/watch?v=... ou youtu.be/..."
            />
          </div>
        </div>
        <images-input
          v-model="newRaffleForm.images"
          @updateRaffle="getRaffle"
          @loading="handleLoading"
          :raffleId="newRaffleForm.id"
        />
      </div>

      <div class="card border mb-3 p-3 ebook-card">
        <div class="form-check form-switch mb-2">
          <input
            id="ebookEnabled"
            v-model="newRaffleForm.ebook_enabled"
            class="form-check-input"
            type="checkbox"
          />
          <label class="form-check-label font-weight-bold" for="ebookEnabled">
            Incluir e-book (produto digital)
          </label>
        </div>
        <p class="text-xs text-secondary mb-3">
          O comprador recebe o PDF após o pagamento aprovado, junto com o
          comprovante.
        </p>
        <template v-if="newRaffleForm.ebook_enabled">
          <div class="input-group input-group-outline m-0 d-flex flex-column mb-3">
            <label class="input-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder"
                >Título do e-book</span
              >
              <input
                v-model="newRaffleForm.ebook_title"
                type="text"
                maxlength="200"
                class="form-control default-bordered-input"
                placeholder="Ex.: Guia de estratégias"
              />
            </label>
          </div>
          <div class="mb-1">
            <label class="text-xs text-uppercase text-body font-weight-bolder"
              >Arquivo PDF (máx. 25 MB)</label
            >
            <input
              type="file"
              class="form-control default-bordered-input mt-1"
              accept="application/pdf,.pdf"
              @change="onEbookFileSelected"
            />
            <small v-if="newRaffleForm.ebook_filename" class="text-success text-xs d-block mt-1">
              Arquivo atual: {{ newRaffleForm.ebook_filename }}
              <span v-if="!newRaffleForm.ebook_file"> (mantido)</span>
            </small>
          </div>
        </template>
      </div>

      <!-- Caixinha Premiada -->
      <div class="card border mb-3 p-3 ebook-card">
        <div class="form-check form-switch mb-2">
          <input
            id="caixinhaEnabled"
            v-model="newRaffleForm.caixinha_enabled"
            class="form-check-input"
            type="checkbox"
          />
          <label
            class="form-check-label font-weight-bold prize-game-field-label"
            for="caixinhaEnabled"
          >
            <img :src="prizeGameIcon('caixinha')" alt="" class="prize-game-field-icon" />
            {{ prizeGameLabel('caixinha') }}
          </label>
        </div>
        <p class="text-xs text-secondary mb-3">
          Cadastre números <strong>específicos</strong> da {{ prizeGameLabel('caixinha') }}. O comprador abre as caixas no checkout após o pagamento.
        </p>
        <template v-if="newRaffleForm.caixinha_enabled">
          <button
            type="button"
            class="btn mb-0 option-button w-100 prize-game-option-btn"
            @click.prevent="openAwardedQuotes('caixinha')"
            :disabled="newRaffleForm.type == 'MANUAL'"
          >
            <img :src="prizeGameIcon('caixinha')" alt="" class="prize-game-btn-icon" />
            {{ prizeGameNumbersButtonLabel('caixinha') }} ({{ (newRaffleForm.caixinha_quotas || []).length }})
          </button>
          <small class="text-xs text-secondary d-block mt-2">
            Cadastre os números + prêmios da {{ prizeGameLabel('caixinha') }}. Quantidade de caixas ganhas: configurada em Promoções.
          </small>
        </template>
      </div>

      <!-- Roleta Premiada -->
      <div class="card border mb-3 p-3 ebook-card">
        <div class="form-check form-switch mb-2">
          <input
            id="roletaEnabled"
            v-model="newRaffleForm.roleta_enabled"
            class="form-check-input"
            type="checkbox"
          />
          <label
            class="form-check-label font-weight-bold prize-game-field-label"
            for="roletaEnabled"
          >
            <img :src="prizeGameIcon('roleta')" alt="" class="prize-game-field-icon" />
            {{ prizeGameLabel('roleta') }}
          </label>
        </div>
        <p class="text-xs text-secondary mb-3">
          Cadastre números <strong>específicos</strong> da {{ prizeGameLabel('roleta') }}. O comprador gira a roleta animada no checkout após o pagamento.
        </p>
        <template v-if="newRaffleForm.roleta_enabled">
          <button
            type="button"
            class="btn mb-0 option-button w-100 prize-game-option-btn"
            @click.prevent="openAwardedQuotes('roleta')"
            :disabled="newRaffleForm.type == 'MANUAL'"
          >
            <img :src="prizeGameIcon('roleta')" alt="" class="prize-game-btn-icon" />
            {{ prizeGameNumbersButtonLabel('roleta') }} ({{ (newRaffleForm.roleta_quotas || []).length }})
          </button>
          <small class="text-xs text-secondary d-block mt-2">
            Cadastre os números + prêmios da {{ prizeGameLabel('roleta') }}. Quantidade de giros ganhos: configurada em Promoções.
          </small>
        </template>
      </div>

      <!-- Raspadinha Premiada -->
      <div class="card border mb-3 p-3 ebook-card">
        <div class="form-check form-switch mb-2">
          <input
            id="raspadinhaEnabled"
            v-model="newRaffleForm.raspadinha_enabled"
            class="form-check-input"
            type="checkbox"
          />
          <label
            class="form-check-label font-weight-bold prize-game-field-label"
            for="raspadinhaEnabled"
          >
            <img :src="prizeGameIcon('raspadinha')" alt="" class="prize-game-field-icon" />
            {{ prizeGameLabel('raspadinha') }}
          </label>
        </div>
        <p class="text-xs text-secondary mb-3">
          Cadastre números <strong>específicos</strong> da {{ prizeGameLabel('raspadinha') }}. O comprador raspa a cartela interativa com o dedo/mouse no checkout.
        </p>
        <template v-if="newRaffleForm.raspadinha_enabled">
          <button
            type="button"
            class="btn mb-0 option-button w-100 prize-game-option-btn"
            @click.prevent="openAwardedQuotes('raspadinha')"
            :disabled="newRaffleForm.type == 'MANUAL'"
          >
            <img :src="prizeGameIcon('raspadinha')" alt="" class="prize-game-btn-icon" />
            {{ prizeGameNumbersButtonLabel('raspadinha') }} ({{ (newRaffleForm.raspadinha_quotas || []).length }})
          </button>
          <small class="text-xs text-secondary d-block mt-2">
            Cadastre os números + prêmios da {{ prizeGameLabel('raspadinha') }}. Quantidade de raspadinhas ganhas: configurada em Promoções.
          </small>
        </template>
      </div>

      <div class="card border mb-3 p-3 ebook-card">
        <div class="form-check form-switch mb-2">
          <input
            id="flashOfferEnabled"
            v-model="newRaffleForm.flash_offer_enabled"
            class="form-check-input"
            type="checkbox"
          />
          <label class="form-check-label font-weight-bold" for="flashOfferEnabled">
            Oferta Relâmpago
          </label>
        </div>
        <p class="text-xs text-secondary mb-3">
          Antes do Pix, o comprador vê uma oferta para levar cotas extras por um
          valor especial (upsell no checkout). Até 2 ofertas.
        </p>
        <template v-if="newRaffleForm.flash_offer_enabled">
          <div
            v-for="(offer, idx) in newRaffleForm.flash_offers"
            :key="'flash-' + idx"
            class="border rounded p-3 mb-3"
            style="background: #fafafa"
          >
            <div class="d-flex justify-content-between align-items-center mb-2">
              <strong class="text-sm">Oferta {{ idx + 1 }}</strong>
              <button
                type="button"
                class="btn btn-sm btn-outline-danger mb-0"
                v-if="newRaffleForm.flash_offers.length > 1"
                @click.prevent="removeFlashOffer(idx)"
              >
                Remover
              </button>
            </div>
            <div class="input-group input-group-outline m-0 d-flex flex-column mb-2">
              <label class="input-label">
                <span class="text-xs text-uppercase text-body font-weight-bolder"
                  >Título *</span
                >
                <input
                  v-model="offer.title"
                  type="text"
                  maxlength="120"
                  class="form-control default-bordered-input"
                  placeholder="Ex.: Leve +50 cotas agora"
                />
              </label>
            </div>
            <div class="input-group input-group-outline m-0 d-flex flex-column mb-2">
              <label class="input-label">
                <span class="text-xs text-uppercase text-body font-weight-bolder"
                  >Subtítulo</span
                >
                <input
                  v-model="offer.subtitle"
                  type="text"
                  maxlength="255"
                  class="form-control default-bordered-input"
                  placeholder="Ex.: Por apenas R$ 9,90 a mais"
                />
              </label>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <div class="input-group input-group-outline m-0 d-flex flex-column flex-grow-1">
                <label class="input-label">
                  <span class="text-xs text-uppercase text-body font-weight-bolder"
                    >Cotas extras *</span
                  >
                  <input
                    v-model.number="offer.extra_quotas"
                    type="number"
                    min="1"
                    class="form-control default-bordered-input"
                    placeholder="50"
                  />
                </label>
              </div>
              <div class="input-group input-group-outline m-0 d-flex flex-column flex-grow-1">
                <label class="input-label">
                  <span class="text-xs text-uppercase text-body font-weight-bolder"
                    >Preço da oferta (R$) *</span
                  >
                  <input
                    v-model="offer.price"
                    type="text"
                    class="form-control default-bordered-input"
                    placeholder="9,90"
                    @input="onFlashOfferPriceInput(idx, $event)"
                  />
                </label>
              </div>
              <div class="input-group input-group-outline m-0 d-flex flex-column flex-grow-1">
                <label class="input-label">
                  <span class="text-xs text-uppercase text-body font-weight-bolder"
                    >Selo</span
                  >
                  <input
                    v-model="offer.badge_label"
                    type="text"
                    maxlength="60"
                    class="form-control default-bordered-input"
                    placeholder="Oferta Relâmpago"
                  />
                </label>
              </div>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-outline-primary mb-0"
            v-if="newRaffleForm.flash_offers.length < 2"
            @click.prevent="addFlashOffer"
          >
            + Adicionar 2ª oferta
          </button>
        </template>
      </div>

      <div class="d-flex flex-direction-row gap-3 three-fields">
        <div class="input-group input-group-outline m-0 d-flex flex-column">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Quantidade de cotas *</span
            >
            <select
              :disabled="isEditFormAndPaid"
              v-model.number="newRaffleForm.qnt_quotas"
              class="form-control default-bordered-input"
            >
              <option
                v-for="quota in quotas"
                :key="quota.value"
                :value="quota.value"
              >
                {{ quota.text }}
              </option>
            </select>
          </label>
        </div>

        <div class="input-group input-group-outline m-0 d-flex flex-column">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Quantidade minima de cotas por compra *</span
            >
            <input
              v-model="newRaffleForm.minimum_purchase"
              @input="
                (e) => {
                  newRaffleForm.minimum_purchase = formatNumberInput(
                    e.target.value,
                    'minimum_purchase'
                  );
                }
              "
              type="text"
              class="form-control default-bordered-input"
              placeholder="Insira a quantidade mínima"
            />
          </label>
        </div>

        <div class="input-group input-group-outline m-0 d-flex flex-column">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Quantidade máxima de cotas por compra *</span
            >
            <input
              v-model="newRaffleForm.maximum_purchase"
              @input="
                (e) => {
                  newRaffleForm.maximum_purchase = formatNumberInput(
                    e.target.value,
                    'maximum_purchase'
                  );
                }
              "
              type="text"
              class="form-control default-bordered-input"
              placeholder="Insira a quantidade máxima"
            />
          </label>
        </div>
      </div>

      <div class="d-flex flex-direction-row gap-3 three-fields">
        <div class="input-group input-group-outline m-0 d-flex flex-column">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Valor das cotas *</span
            >
            <input
              :disabled="isEditFormAndPaid"
              v-model.lazy="newRaffleForm.quota_price"
              v-money3="config"
              type="text"
              class="form-control default-bordered-input"
            />
          </label>
        </div>

        <div class="input-group input-group-outline m-0 d-flex flex-column">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Local de sorteio *</span
            >
            <select
              :disabled="isEditFormAndPaid"
              v-model="newRaffleForm.drawer"
              class="form-control default-bordered-input"
              id="exampleFormControlSelect1"
            >
              <option
                v-for="drawer in raffleDrawer"
                :key="drawer.value"
                :value="drawer.value"
              >
                {{ drawer.text }}
              </option>
            </select>
          </label>
        </div>

        <div class="input-group input-group-outline m-0 d-flex flex-column">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Filtro inicial das cotas *</span
            >
            <select
              v-model="newRaffleForm.show_type"
              class="form-control default-bordered-input"
              id="exampleFormControlSelect1"
            >
              <option
                v-for="type in showType"
                :key="type.value"
                :value="type.value"
              >
                {{ type.text }}
              </option>
            </select>
          </label>
        </div>
      </div>

      <div class="d-flex flex-direction-row gap-3 mt-3">
        <div class="input-group input-group-outline m-0 d-flex flex-column flex-grow-1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Flag de exibição</span
            >
            <select
              v-model="newRaffleForm.display_flag_label"
              class="form-control default-bordered-input"
              @change="onDisplayFlagPreset"
            >
              <option
                v-for="flag in displayFlagPresets"
                :key="flag.value"
                :value="flag.value"
              >
                {{ flag.text }}
              </option>
            </select>
          </label>
          <small class="text-secondary text-xs mt-1">
            Aparece como selo no topo da página da rifa (igual sistemas grandes).
          </small>
        </div>
        <div
          class="input-group input-group-outline m-0 d-flex flex-column"
          style="min-width: 160px"
          v-if="newRaffleForm.display_flag_label"
        >
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Cor da flag</span
            >
            <select
              v-model="newRaffleForm.display_flag_color"
              class="form-control default-bordered-input"
            >
              <option
                v-for="c in displayFlagColors"
                :key="c.value"
                :value="c.value"
              >
                {{ c.text }}
              </option>
            </select>
          </label>
          <div
            class="display-flag-preview mt-2"
            :class="'flag-' + (newRaffleForm.display_flag_color || 'green')"
          >
            {{ newRaffleForm.display_flag_label }}
          </div>
        </div>
      </div>

      <div class="d-flex flex-direction-row gap-3 mt-3" v-if="newRaffleForm.type === 'AUTO'">
        <div class="input-group input-group-outline m-0 d-flex flex-column flex-grow-1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Modelo da página pública</span
            >
            <select
              v-model="newRaffleForm.landing_template"
              class="form-control default-bordered-input"
            >
              <option value="default">Modelo 1 — Padrão Rifa365</option>
              <option value="premium">Modelo 2 - Premium</option>
            </select>
          </label>
          <small class="text-secondary text-xs mt-1">
            Só rifas automáticas. Modelo 2 usa o layout premium na página pública.
          </small>
        </div>
      </div>

      <div class="input-group input-group-outline m-0 d-flex flex-column">
        <label class="input-label">
          <span class="text-xs text-uppercase text-body font-weight-bolder"
            >Número de celular *</span
          >
          <PhoneInput v-model="newRaffleForm.phone" />
        </label>
      </div>

      <div class="d-flex flex-direction-row gap-3">
        <div class="input-group input-group-outline m-0 d-flex flex-column">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Tempo para pagamento *</span
            >
            <select
              v-model="newRaffleForm.payment_time"
              class="form-control default-bordered-input"
              id="exampleFormControlSelect1"
            >
              <option
                v-for="duration in durations"
                :key="duration.value"
                :value="duration.value"
              >
                {{ duration.text }}
              </option>
            </select>
          </label>
        </div>

        <div
          class="input-group input-group-outline m-0 d-flex flex-column"
          v-if="newRaffleForm.hasDate"
        >
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Data e hora do sorteio</span
            >
            <input
              v-model="newRaffleForm.draw_date"
              type="datetime-local"
              class="form-control default-bordered-input"
            />
          </label>
        </div>
      </div>

      <div class="feature-toggles-grid">
        <div
          class="input-group input-group-outline m-0 d-flex flex-column check-field"
        >
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Data de sorteio
            </span>

            <div class="form-check form-switch mt-2 switch-field">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="newRaffleForm.hasDate"
              />
              <label class="form-check-label">Informar data</label>
            </div>
          </label>
        </div>

        <div
          class="input-group input-group-outline m-0 d-flex flex-column check-field"
        >
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Solicitar e-mail
            </span>

            <div class="form-check form-switch mt-2 switch-field">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="newRaffleForm.required_email"
              />
              <label class="form-check-label">Requirir e-mail na compra</label>
            </div>
          </label>
        </div>

        <div
          class="input-group input-group-outline m-0 d-flex flex-column check-field"
        >
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Confirmação de idade (18+)
            </span>

            <div class="form-check form-switch mt-2 switch-field">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="newRaffleForm.age_gate_enabled"
              />
              <label class="form-check-label"
                >Exibir popup pedindo confirmação de maioridade</label
              >
            </div>
            <p class="text-xs text-secondary mb-0 mt-1">
              Ao entrar na página, o visitante confirma que tem 18 anos ou mais.
              Se marcar “Não”, é redirecionado para fora da campanha. O “Sim” fica
              registrado nos logs.
            </p>
          </label>
        </div>

        <div
          class="input-group input-group-outline m-0 d-flex flex-column check-field"
        >
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Ranking diário
            </span>

            <div class="form-check form-switch mt-2 switch-field">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="newRaffleForm.show_ranking"
              />
              <label class="form-check-label">Exibir ranking</label>
            </div>
            <div
              v-if="newRaffleForm.show_ranking"
              class="form-check form-switch mt-2 switch-field"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="newRaffleForm.ranking_show_quotas"
              />
              <label class="form-check-label"
                >Exibir quantidade de bilhetes (nome + qtd)</label
              >
            </div>
          </label>
        </div>
        <div
          class="input-group input-group-outline m-0 d-flex flex-column check-field"
        >
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Página de ganhadores
            </span>

            <div class="form-check form-switch mt-2 switch-field">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="newRaffleForm.show_winners_page"
              />
              <label class="form-check-label">Exibir página pública de ganhadores</label>
            </div>
          </label>
        </div>
        <div
          class="input-group input-group-outline m-0 d-flex flex-column check-field"
        >
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Maior e Menor Cota
            </span>

            <div class="form-check form-switch mt-2 switch-field">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="newRaffleForm.show_min_max_quotas"
              />
              <label class="form-check-label">Exibir maior e menor cota na campanha</label>
            </div>
          </label>
        </div>
        <div
          class="input-group input-group-outline m-0 d-flex flex-column check-field"
        >
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Cota em Dobro
            </span>

            <div class="form-check form-switch mt-2 switch-field">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="newRaffleForm.double_quotas_enabled"
              />
              <label class="form-check-label">Ativar cota em dobro na campanha</label>
            </div>
          </label>
        </div>
      </div>

      <div
        v-if="newRaffleForm.double_quotas_enabled"
        class="d-flex flex-direction-row gap-3 mt-3 ranking-window-fields"
      >
        <div class="input-group input-group-outline m-0 d-flex flex-column" style="flex: 1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Início da cota em dobro (data e hora)
            </span>
            <input
              type="datetime-local"
              class="form-control"
              v-model="newRaffleForm.double_quotas_start_at"
            />
          </label>
        </div>
        <div class="input-group input-group-outline m-0 d-flex flex-column" style="flex: 1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Fim da cota em dobro (data e hora)
            </span>
            <input
              type="datetime-local"
              class="form-control"
              v-model="newRaffleForm.double_quotas_end_at"
            />
          </label>
        </div>
        <div class="input-group input-group-outline m-0 d-flex flex-column" style="flex: 1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Qtd. mínima de cotas para dobrar (0 = todas)
            </span>
            <input
              type="number"
              min="0"
              class="form-control"
              placeholder="Ex: 20 (opcional)"
              v-model.number="newRaffleForm.double_quotas_min_quotas"
            />
          </label>
        </div>
      </div>

      <div
        v-if="newRaffleForm.show_min_max_quotas"
        class="d-flex flex-direction-row gap-3 mt-3 ranking-window-fields"
      >
        <div class="input-group input-group-outline m-0 d-flex flex-column" style="flex: 1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Início da maior e menor cota (data e hora)
            </span>
            <input
              type="datetime-local"
              class="form-control"
              v-model="newRaffleForm.min_max_quotas_start_at"
            />
          </label>
        </div>
        <div class="input-group input-group-outline m-0 d-flex flex-column" style="flex: 1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Fim da maior e menor cota (data e hora)
            </span>
            <input
              type="datetime-local"
              class="form-control"
              v-model="newRaffleForm.min_max_quotas_end_at"
            />
          </label>
        </div>
      </div>

      <div
        v-if="newRaffleForm.show_ranking"
        class="d-flex flex-direction-row gap-3 mt-3 ranking-window-fields"
      >
        <div class="input-group input-group-outline m-0 d-flex flex-column" style="flex: 1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Início do ranking (data e hora)
            </span>
            <input
              type="datetime-local"
              class="form-control"
              v-model="newRaffleForm.ranking_start_at"
            />
          </label>
        </div>
        <div class="input-group input-group-outline m-0 d-flex flex-column" style="flex: 1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Fim do ranking (data e hora)
            </span>
            <input
              type="datetime-local"
              class="form-control"
              v-model="newRaffleForm.ranking_end_at"
            />
          </label>
        </div>
      </div>
      <div
        v-if="newRaffleForm.show_ranking"
        class="d-flex flex-direction-row gap-3 mt-3 ranking-prize-fields"
      >
        <div class="input-group input-group-outline m-0 d-flex flex-column" style="flex: 1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Prêmio 1º lugar
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Ex: R$3.000,00 no Pix!"
              v-model="newRaffleForm.ranking_prize_1"
              maxlength="255"
            />
          </label>
        </div>
        <div class="input-group input-group-outline m-0 d-flex flex-column" style="flex: 1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Prêmio 2º lugar
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Ex: R$2.000,00 no Pix!"
              v-model="newRaffleForm.ranking_prize_2"
              maxlength="255"
            />
          </label>
        </div>
        <div class="input-group input-group-outline m-0 d-flex flex-column" style="flex: 1">
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Prêmio 3º lugar
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="Ex: R$1.000,00 no Pix!"
              v-model="newRaffleForm.ranking_prize_3"
              maxlength="255"
            />
          </label>
        </div>
      </div>
      <p
        v-if="newRaffleForm.show_ranking"
        class="text-xs text-secondary mt-2 mb-0"
      >
        Com início e fim preenchidos, o ranking conta só compras aprovadas nesse
        período. Fora do prazo o card some automaticamente na página da rifa.
        Sem datas, continua o ranking geral. Prêmios são opcionais e aparecem
        no card quando preenchidos. Em “Exibir quantidade de bilhetes”: ligado
        mostra nome + qtd; desligado mostra só o nome dos líderes.
      </p>

      <div class="d-flex flex-direction-row gap-3 mt-3">
        <div
          class="input-group input-group-outline m-0 d-flex flex-column check-field"
        >
          <label class="input-label">
            <span class="text-xs text-uppercase text-body font-weight-bolder">
              Barra de progresso
            </span>

            <div class="form-check form-switch mt-2 switch-field">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="newRaffleForm.show_progress_bar"
              />
              <label class="form-check-label">Exibir barra de progresso</label>
            </div>
          </label>
        </div>
      </div>

      <div class="d-flex flex-direction-row gap-3 three-fields">
        <div
          style="width: 100%"
          v-tooltip.right="{
            value: 'Função não disponível para campanhas manuais',
            disabled: newRaffleForm.type == 'AUTO',
            pt: {
              root: {
                style: {
                  marginLeft: '8px',
                },
              },
              text: {
                style: {
                  fontSize: '14px',
                },
              },
            },
          }"
        >
          <button
            class="btn mb-0 option-button prize-game-option-btn"
            @click.prevent="openAwardedQuotes('cota')"
            :disabled="newRaffleForm.type == 'MANUAL'"
          >
            <img :src="prizeGameIcon('cota')" alt="" class="prize-game-btn-icon" />
            {{ prizeGameLabel('cota') }}
          </button>
        </div>

        <div style="width: 100%">
          <button
            class="btn mb-0 option-button"
            @click.prevent="this.prizesDialog = true"
          >
            <i class="material-icons">emoji_events</i>
            Prêmio
          </button>
        </div>

        <div style="width: 100%">
          <button
            class="btn mb-0 option-button"
            @click.prevent="this.promotionsDialog = true"
          >
            <i class="material-icons">paid</i>
            Promoção
          </button>
        </div>
      </div>

      <!-- AREA DO CUPOM -->
      <div class="row mt-4">
        <div class="col-12 col-md-6 col-lg-4">
          <label class="input-label w-100">
            <span class="text-xs text-uppercase text-body font-weight-bolder"
              >Cupom de Desconto</span
            >
          </label>
          <div
            class="input-group input-group-outline m-0 d-flex"
            style="flex-wrap: nowrap"
          >
            <input
              v-model="couponCode"
              type="text"
              class="form-control default-bordered-input text-uppercase"
              style="border-top-right-radius: 0; border-bottom-right-radius: 0"
              placeholder="INSIRA SEU CÓDIGO"
              :disabled="couponData != null"
              @keyup.enter="validateCoupon"
            />
            <button
              v-if="!couponData"
              class="btn bg-gradient-success mb-0"
              style="
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                white-space: nowrap;
              "
              @click.prevent="validateCoupon"
              :disabled="couponLoading || !couponCode"
            >
              {{ couponLoading ? "..." : "APLICAR" }}
            </button>
            <button
              v-else
              class="btn btn-outline-danger mb-0"
              style="
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                white-space: nowrap;
                border: 1px solid #f44335;
              "
              @click.prevent="removeCoupon"
            >
              REMOVER
            </button>
          </div>
          <small
            v-if="couponError"
            class="text-danger mt-1 d-block text-xs font-weight-bold"
          >
            {{ couponError }}
          </small>
          <small
            v-if="couponSuccess"
            class="text-success mt-1 d-block text-xs font-weight-bold"
          >
            {{ couponSuccess }}
          </small>
        </div>
      </div>
      <!-- FIM AREA DO CUPOM -->

      <div class="total-value">
        <div class="taxes-field">
          <span class="total-value-title"> Taxas de publicação </span>

          <button
            class="btn mb-0 taxes-button"
            @click.prevent="this.taxesDialog = true"
          >
            Ver taxas
          </button>
        </div>

        <div>
          <div class="total-value-values">
            <span>Taxa de publicação</span>
            <span
              class="negative"
              :style="
                couponData ? 'text-decoration: line-through; opacity: 0.7;' : ''
              "
            >
              - {{ publicationFee }}
            </span>
          </div>
          <div class="total-value-values" v-if="couponData">
            <span class="text-success">Desconto Cupom</span>
            <span class="text-success">
              + R$ {{ couponData.discount_value.toFixed(2) }}
            </span>
          </div>
          <div class="total-value-values" v-if="couponData">
            <span class="font-weight-bold">Taxa Final</span>
            <span class="negative font-weight-bold">
              - R$ {{ couponData.final_value.toFixed(2) }}
            </span>
          </div>

          <div class="total-value-values">
            <span>Arrecadação estimada</span>
            <span class="positive"> + {{ estimatedProfit }} </span>
          </div>
        </div>
      </div>

      <div class="terms" v-if="!isEditFormAndPaid">
        <div
          class="input-group input-group-outline m-0 d-flex flex-column check-field"
        >
          <label class="input-label">
            <div>
              <Checkbox
                v-model="acceptTerms"
                binary
                size="small"
                style="margin: 0 8px 0 0; padding: 0"
              />
              <span class="text-body">
                Ao criar esta campanha, você aceita nossos
                <a class="terms-button" @click.prevent="this.termsDialog = true"
                  >Termos de Uso</a
                >
                e a nossa
                <a
                  class="terms-button"
                  @click.prevent="this.policyDialog = true"
                  >Política de Privacidade</a
                >.
              </span>
            </div>
          </label>
        </div>
      </div>

      <div class="mt-2 full-width d-flex justify-content-between">
        <button
          class="btn mb-0 cancel-button"
          @click.prevent="this.$router.push('/')"
        >
          Cancelar
        </button>

        <button class="btn mb-0 submit-button" @click.prevent="submitRaffle">
          {{ formButton }}
          <i class="material-icons ticket-icon">arrow_forward</i>
        </button>
      </div>
    </form>

    <AwardedQuoteDialog
      :isOpen="isAwardedQuotesOpen"
      @close="isAwardedQuotesOpen = false"
      v-model:awardedQuotes="activeAwardedQuotesList"
      :receivedData="activeAwardedQuotesList"
      :campaignId="newRaffleForm.id || null"
      :variant="awardedQuotesVariant"
      :quotaKind="activeAwardedQuotesKind"
      v-model:prizeReleaseEnabled="newRaffleForm.prize_release_enabled"
      v-model:prizeReleaseRules="newRaffleForm.prize_release_rules"
      :prizeReleaseSoldPct="newRaffleForm.prize_release_sold_pct || 0"
      :prizeReleaseBlocked="newRaffleForm.prize_release_blocked || 0"
      :prizeReleaseReleased="newRaffleForm.prize_release_released || 0"
      @prize-release-saved="onPrizeReleaseSaved"
    />

    <PrizesDialog
      :isOpen="prizesDialog"
      @close="prizesDialog = false"
      v-model:awardedQuotes="newRaffleForm.awards"
      :receivedData="newRaffleForm.awards"
      :campaignId="newRaffleForm.id || null"
      :isCampaignPaid="newRaffleForm.status == 'ACTIVE'"
    />

    <PromotionsDialog
      :isOpen="promotionsDialog"
      @close="promotionsDialog = false"
      v-model:promotions="newRaffleForm.promotions"
      :receivedData="newRaffleForm.promotions"
      :campaignId="newRaffleForm.id || null"
    />

    <TaxesDialog :isOpen="taxesDialog" @close="taxesDialog = false" />

    <Terms :isOpen="termsDialog" @close="termsDialog = false" />

    <Policy :isOpen="policyDialog" @close="policyDialog = false" />

    <SystemWalletWarningDialog :isOpen="systemWalletWarningDialog" @close="systemWalletWarningDialog = false" />
  </div>

  <Loading v-if="loading" />
</template>

<script>
import { MaskInput } from "maska";
import { vMaska } from "maska/vue";
import Editor from "primevue/editor";
import ImagesInput from "@/views/components/ImagesInput.vue";
import AwardedQuoteDialog from "@/views/Raffles/RafflesCreation/components/AwardedQuoteDialog.vue";
import PrizesDialog from "@/views/Raffles/RafflesCreation/components/PrizesDialog.vue";
import PromotionsDialog from "@/views/Raffles/RafflesCreation/components/PromotionsDialog.vue";
import TaxesDialog from "@/views/Raffles/RafflesCreation/components/TaxesDialog.vue";
import Terms from "@/views/Raffles/RafflesCreation/components/Terms.vue";
import Policy from "@/views/Raffles/RafflesCreation/components/Policy.vue";
import SystemWalletWarningDialog from "@/views/Raffles/RafflesCreation/components/SystemWalletWarningDialog.vue";
import RafflesHttp from "../../../http/RafflesHttp";
import { RouteName } from "../../../store/routeName";
import Loading from "@/components/Loading.vue";
import DefaultInput from "@/components/DefaultInput.vue";
import PhoneInput from "@/components/PhoneInput.vue";
import Checkbox from "primevue/checkbox";
import LoggingMixin from "@/mixins/LoggingMixin";
import {
  prizeGameIcon,
  prizeGameLabel,
  prizeGameNumbersButtonLabel,
} from "@/constants/prizeGames";
import http from "@/configs/AxiosConfig";

export default {
  name: "new-raffle",
  mixins: [LoggingMixin],
  components: {
    Editor,
    ImagesInput,
    AwardedQuoteDialog,
    PrizesDialog,
    Loading,
    DefaultInput,
    PhoneInput,
    PromotionsDialog,
    TaxesDialog,
    Terms,
    Policy,
    Checkbox,
    SystemWalletWarningDialog,
  },
  directives: {
    maska: vMaska,
  },
  data() {
    return {
      loading: false,
      innerWidth: window.innerWidth,
      isAwardedQuotesOpen: false,
      awardedQuotesVariant: "cota",
      prizesDialog: false,
      promotionsDialog: false,
      taxesDialog: false,
      termsDialog: false,
      policyDialog: false,
      systemWalletWarningDialog: false,
      reportingError: false,
      cooldownRemaining: 0,
      acceptTerms: false,
      newRaffleForm: {
        id_user: 0,
        name: "",
        qnt_quotas: 100,
        quota_price: "0",
        minimum_purchase: null,
        maximum_purchase: null,
        drawer: "LOTERIA",
        phone: "",
        type: "MANUAL",
        description: "",
        draw_date: "",
        hasDate: false,
        required_email: false,
        age_gate_enabled: false,
        payment_time: "1h",
        show_type: "ALL_QUOTAS",
        display_flag_label: "",
        display_flag_color: "green",
        landing_template: "default",
        layout_style: "classic",
        show_ranking: false,
        ranking_show_quotas: true,
        ranking_start_at: "",
        ranking_end_at: "",
        ranking_prize_1: "",
        ranking_prize_2: "",
        ranking_prize_3: "",
        show_min_max_quotas: false,
        min_max_quotas_start_at: "",
        min_max_quotas_end_at: "",
        double_quotas_enabled: false,
        double_quotas_start_at: "",
        double_quotas_end_at: "",
        double_quotas_min_quotas: 0,
        show_progress_bar: false,
        show_winners_page: false,
        images: [],
        gallery_youtube_url: "",
        awards: [],
        awarded_quotas: [],
        caixinha_quotas: [],
        roleta_quotas: [],
        raspadinha_quotas: [],
        promotions: [],
        ebook_enabled: false,
        caixinha_enabled: false,
        caixinha_type: "caixa",
        roleta_enabled: false,
        raspadinha_enabled: false,
        prize_release_enabled: false,
        prize_release_rules: [],
        prize_release_blocked: 0,
        prize_release_released: 0,
        prize_release_sold_pct: 0,
        flash_offer_enabled: false,
        flash_offers: [
          {
            title: "",
            subtitle: "",
            badge_label: "Oferta Relâmpago",
            extra_quotas: 10,
            price: "9,90",
            is_active: true,
          },
        ],
        ebook_title: "",
        ebook_filename: "",
        ebook_file: null,
      },
      quotas: [
        { value: 25, text: "25 cotas" },
        { value: 50, text: "50 cotas" },
        { value: 100, text: "100 cotas" },
        { value: 200, text: "200 cotas" },
        { value: 300, text: "300 cotas" },
        { value: 400, text: "400 cotas" },
        { value: 500, text: "500 cotas" },
        { value: 600, text: "600 cotas" },
        { value: 700, text: "700 cotas" },
        { value: 800, text: "800 cotas" },
        { value: 900, text: "900 cotas" },
        { value: 1000, text: "1.000 cotas" },
        { value: 2000, text: "2.000 cotas" },
        { value: 3000, text: "3.000 cotas" },
        { value: 4000, text: "4.000 cotas" },
        { value: 5000, text: "5.000 cotas" },
        { value: 6000, text: "6.000 cotas" },
        { value: 10000, text: "10.000 cotas" },
        { value: 20000, text: "20.000 cotas" },
        { value: 30000, text: "30.000 cotas" },
        { value: 50000, text: "50.000 cotas" },
        { value: 100000, text: "100.000 cotas" },
        { value: 500000, text: "500.000 cotas" },
        { value: 1000000, text: "1.000.000 cotas" },
      ],
      durations: [
        { value: "10m", text: "10 minutos" },
        { value: "30m", text: "30 minutos" },
        { value: "1h", text: "1 hora" },
        { value: "1d", text: "1 dia" },
        { value: "3d", text: "3 dias" },
      ],
      raffleDrawer: [
        { value: "LOTERIA", text: "Loteria Federal" },
        { value: "SORTEADOR", text: "Sorteador 365" },
        { value: "INSTAGRAM", text: "Live no Instagram" },
        { value: "YOUTUBE", text: "Live no Youtube" },
        { value: "TIKTOK", text: "Live no TikTok" },
        { value: "OTHER", text: "Outros" },
      ],
      showType: [
        { value: "ALL_QUOTAS", text: "Mostrar todas as cotas" },
        {
          value: "AVAILABLE_QUOTAS",
          text: "Mostrar somente cotas disponíveis",
        },
      ],
      displayFlagPresets: [
        { value: "", text: "Sem flag" },
        { value: "Adquira já!", text: "Adquira já!" },
        { value: "Adquira agora!", text: "Adquira agora!" },
        {
          value: "Corre que está acabando!",
          text: "Corre que está acabando!",
        },
        {
          value: "Corre que essa vai rápido! 🔥",
          text: "Corre que essa vai rápido! 🔥",
        },
        { value: "Aguarde a campanha!", text: "Aguarde a campanha!" },
        { value: "Em breve!", text: "Em breve!" },
        { value: "Aguarde o sorteio!", text: "Aguarde o sorteio!" },
        { value: "Concluído", text: "Concluído" },
      ],
      displayFlagColors: [
        { value: "green", text: "Verde (disponível)" },
        { value: "red", text: "Vermelho (urgência)" },
        { value: "orange", text: "Laranja" },
        { value: "black", text: "Preto (finalizada)" },
        { value: "purple", text: "Roxo" },
        { value: "blue", text: "Azul" },
      ],
      editorKey: 0,
      aiCaptionBrief: "",
      generatingCaption: false,
      aiCaptionHint: "",
      // Coupon Logic
      couponCode: "",
      couponData: null,
      couponLoading: false,
      couponError: "",
      couponSuccess: "",
      user: null, // Add user object
    };
  },

  computed: {
    config() {
      return {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        disableNegative: true,
        masked: false,
      };
    },
    pageTitle() {
      return this.$route.name == RouteName.NewRaffle
        ? "Nova campanha"
        : "Editar campanha";
    },
    formButton() {
      return this.$route.name == RouteName.NewRaffle
        ? "Criar campanha"
        : "Editar campanha";
    },
    isPlanActive() {
      const u = this.user;
      if (!u || !u.use_plan) return false;

      if (u.plan_active === 'VITALICIO') return true;

      if ((u.plan_active === 'MENSAL' || u.plan_active === 'ANUAL') && u.plan_expiration) {
        // Separa os componentes da data para evitar problemas de fuso horário (UTC vs Local)
        const [year, month, day] = u.plan_expiration.split('-').map(Number);
        const expDate = new Date(year, month - 1, day, 23, 59, 59);
        return expDate >= new Date();
      }
      return false;
    },
    isLifetime() {
      return this.user?.use_plan && this.user.plan_active === 'VITALICIO';
    },
    caixinhaNumbersButtonLabel() {
      return this.newRaffleForm.caixinha_type === "roleta"
        ? "Números da roleta"
        : "Números da caixinha";
    },
    caixinhaNumbersIcon() {
      return this.newRaffleForm.caixinha_type === "roleta"
        ? "casino"
        : "redeem";
    },
    activeAwardedQuotesKind() {
      return this.awardedQuotesVariant || "cota";
    },
    activeAwardedQuotesList: {
      get() {
        if (this.awardedQuotesVariant === "caixinha") {
          return this.newRaffleForm.caixinha_quotas || [];
        }
        if (this.awardedQuotesVariant === "roleta") {
          return this.newRaffleForm.roleta_quotas || [];
        }
        if (this.awardedQuotesVariant === "raspadinha") {
          return this.newRaffleForm.raspadinha_quotas || [];
        }
        return this.newRaffleForm.awarded_quotas || [];
      },
      set(value) {
        if (this.awardedQuotesVariant === "caixinha") {
          this.newRaffleForm.caixinha_quotas = value || [];
        } else if (this.awardedQuotesVariant === "roleta") {
          this.newRaffleForm.roleta_quotas = value || [];
        } else if (this.awardedQuotesVariant === "raspadinha") {
          this.newRaffleForm.raspadinha_quotas = value || [];
        } else {
          this.newRaffleForm.awarded_quotas = value || [];
        }
      },
    },
    publicationFee() {
      // System Wallet or Plan Fee Exemption
      if (this.user && (!!this.user.system_wallet || this.isPlanActive)) {
        return "R$ 0,00";
      }

      const totalAmount =
        this.newRaffleForm.qnt_quotas *
        this.parseQuotaPrice(this.newRaffleForm.quota_price);
      if (totalAmount === 0) return "R$ 0,00";

      if (totalAmount >= 0 && totalAmount <= 100) return "R$ 5,00";
      if (totalAmount > 100 && totalAmount <= 200) return "R$ 15,00";
      if (totalAmount > 200 && totalAmount <= 400) return "R$ 25,00";
      if (totalAmount > 400 && totalAmount <= 700) return "R$ 35,00";
      if (totalAmount > 700 && totalAmount <= 1000) return "R$ 45,00";
      if (totalAmount > 1000 && totalAmount <= 2000) return "R$ 65,00";
      if (totalAmount > 2000 && totalAmount <= 4000) return "R$ 75,00";
      if (totalAmount > 4000 && totalAmount <= 7000) return "R$ 125,00";
      if (totalAmount > 7000 && totalAmount <= 10000) return "R$ 180,00";
      if (totalAmount > 10000 && totalAmount <= 20000) return "R$ 220,00";
      if (totalAmount > 20000 && totalAmount <= 30000) return "R$ 460,00";
      if (totalAmount > 30000 && totalAmount <= 50000) return "R$ 960,00";
      if (totalAmount > 50000 && totalAmount <= 70000) return "R$ 1.400,00";
      if (totalAmount > 70000 && totalAmount <= 100000) return "R$ 1.900,00";
      if (totalAmount > 100000 && totalAmount <= 150000) return "R$ 2.900,00";
      if (totalAmount > 150000) return "R$ 3.800,00";

      return "R$ 0,00";
    },
    estimatedProfit() {
      return this.newRaffleForm.qnt_quotas && this.newRaffleForm.quota_price
        ? (
            this.newRaffleForm.qnt_quotas *
            this.parseQuotaPrice(this.newRaffleForm.quota_price)
          ).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        : "0.00";
    },
    isEditFormAndPaid() {
      return (
        this.$route.name == RouteName.EditRaffle &&
        this.newRaffleForm.status == "ACTIVE"
      );
    },
  },
  methods: {
    prizeGameIcon,
    prizeGameLabel,
    prizeGameNumbersButtonLabel,
    buildPrizeReleaseRulesPayload() {
      if (!this.newRaffleForm.prize_release_enabled) return [];
      return (this.newRaffleForm.prize_release_rules || [])
        .map((r) => ({
          pct: Number(r.pct) || 0,
          qty: Number(r.qty) || 0,
        }))
        .filter((r) => r.pct >= 1 && r.pct <= 100);
    },
    onPrizeReleaseSaved(data) {
      if (!data || typeof data !== "object") return;
      if (typeof data.prize_release_enabled === "boolean") {
        this.newRaffleForm.prize_release_enabled = data.prize_release_enabled;
      }
      if (Array.isArray(data.prize_release_rules)) {
        this.newRaffleForm.prize_release_rules = data.prize_release_rules.map(
          (r) => ({
            pct: Number(r.pct) || 0,
            qty: Number(r.qty) || 0,
          })
        );
      }
      if (data.prize_release_blocked != null) {
        this.newRaffleForm.prize_release_blocked = data.prize_release_blocked;
      }
      if (data.prize_release_released != null) {
        this.newRaffleForm.prize_release_released = data.prize_release_released;
      }
      if (data.prize_release_sold_pct != null) {
        this.newRaffleForm.prize_release_sold_pct = data.prize_release_sold_pct;
      }
    },
    onDisplayFlagPreset() {
      const label = this.newRaffleForm.display_flag_label || "";
      if (!label) {
        this.newRaffleForm.display_flag_color = "green";
        return;
      }
      const suggested = {
        "Adquira já!": "green",
        "Adquira agora!": "green",
        "Corre que está acabando!": "red",
        "Corre que essa vai rápido! 🔥": "orange",
        "Aguarde a campanha!": "blue",
        "Em breve!": "purple",
        "Aguarde o sorteio!": "blue",
        Concluído: "black",
      };
      if (suggested[label]) {
        this.newRaffleForm.display_flag_color = suggested[label];
      } else if (!this.newRaffleForm.display_flag_color) {
        this.newRaffleForm.display_flag_color = "green";
      }
    },
    emptyFlashOffer() {
      return {
        title: "",
        subtitle: "",
        badge_label: "Oferta Relâmpago",
        extra_quotas: 10,
        price: "9,90",
        is_active: true,
      };
    },
    addFlashOffer() {
      if (!this.newRaffleForm.flash_offers) {
        this.newRaffleForm.flash_offers = [];
      }
      if (this.newRaffleForm.flash_offers.length >= 2) return;
      this.newRaffleForm.flash_offers.push(this.emptyFlashOffer());
    },
    removeFlashOffer(idx) {
      if (!this.newRaffleForm.flash_offers || this.newRaffleForm.flash_offers.length <= 1) {
        return;
      }
      this.newRaffleForm.flash_offers.splice(idx, 1);
    },
    onFlashOfferPriceInput(idx, event) {
      const raw = (event && event.target && event.target.value) || "";
      if (!this.newRaffleForm.flash_offers[idx]) return;
      this.newRaffleForm.flash_offers[idx].price = raw;
    },
    buildFlashOffersPayload() {
      if (!this.newRaffleForm.flash_offer_enabled) {
        return [];
      }
      return (this.newRaffleForm.flash_offers || [])
        .filter((o) => (o.title || "").trim() && Number(o.extra_quotas) > 0)
        .slice(0, 2)
        .map((o, i) => ({
          title: String(o.title || "").trim().slice(0, 120),
          subtitle: String(o.subtitle || "").trim().slice(0, 255),
          badge_label:
            String(o.badge_label || "Oferta Relâmpago").trim().slice(0, 60) ||
            "Oferta Relâmpago",
          extra_quotas: Math.max(1, parseInt(o.extra_quotas, 10) || 1),
          price: this.parseQuotaPrice(o.price || "0") || 0,
          sort_order: i + 1,
          is_active: o.is_active !== false,
        }));
    },
    openAwardedQuotes(variant = "cota") {
      this.awardedQuotesVariant = variant || "cota";
      this.isAwardedQuotesOpen = true;
    },
    openPrizeGameNumbers() {
      const variant =
        this.newRaffleForm.caixinha_type === "roleta" ? "roleta" : "caixinha";
      this.openAwardedQuotes(variant);
    },
    async validateCoupon() {
      if (!this.couponCode) return;

      const currentFee = this.parseQuotaPrice(this.publicationFee);
      if (currentFee <= 0) {
        this.couponError =
          "A taxa de publicação é gratuita, não é necessário cupom.";
        return;
      }

      this.couponLoading = true;
      this.couponError = "";
      this.couponSuccess = "";
      this.couponData = null;

      try {
        // Calcular taxa atual para validar regras

        const payload = {
          code: this.couponCode,
          publication_fee: currentFee,
          user_id: this.$store.getters.user?.id || 0,
        };

        const { data } = await http.post("/coupons/validate", payload);

        if (data.valid) {
          this.couponData = data;
          this.couponSuccess = `Cupom aplicado! Desconto de R$ ${data.discount_value.toFixed(
            2
          )}`;
        } else {
          this.couponError = data.message || "Cupom inválido";
        }
      } catch (error) {
        console.error(error);
        this.couponError = "Erro ao validar cupom";
      } finally {
        this.couponLoading = false;
      }
    },
    removeCoupon() {
      this.couponCode = "";
      this.couponData = null;
      this.couponSuccess = "";
      this.couponError = "";
    },
    parseNumberForStorage(value) {
      return parseInt(String(value).replace(/\./g, "")) || 1;
    },
    async createRaffle() {
      try {
        if (this.validateAllFields()) {
          const user = this.$store.getters.user;

          const newRaffleUpdatedForm = {
            ...this.newRaffleForm,
            id_user: user.id,
            quota_price: this.parseQuotaPrice(
              this.newRaffleForm.quota_price
            ).toString(),
            draw_date: this.getDateIfChecked(),
            publication_fee: this.parseQuotaPrice(this.publicationFee),
            awarded_quotas:
              this.newRaffleForm.type == "MANUAL"
                ? []
                : this.newRaffleForm.awarded_quotas,
            caixinha_quotas:
              this.newRaffleForm.type == "MANUAL" ||
              !this.newRaffleForm.caixinha_enabled
                ? []
                : this.newRaffleForm.caixinha_quotas || [],
            roleta_quotas:
              this.newRaffleForm.type == "MANUAL" ||
              !this.newRaffleForm.roleta_enabled
                ? []
                : this.newRaffleForm.roleta_quotas || [],
            raspadinha_quotas:
              this.newRaffleForm.type == "MANUAL" ||
              !this.newRaffleForm.raspadinha_enabled
                ? []
                : this.newRaffleForm.raspadinha_quotas || [],
            ua: navigator.userAgent,
            minimum_purchase: this.parseNumberForStorage(
              this.newRaffleForm.minimum_purchase
            ),
            maximum_purchase: this.parseNumberForStorage(
              this.newRaffleForm.maximum_purchase
            ),
            id_coupon: this.couponData ? this.couponData.coupon_id : null,
            ebook_enabled: !!this.newRaffleForm.ebook_enabled,
            ebook_title: this.newRaffleForm.ebook_enabled
              ? this.newRaffleForm.ebook_title || "E-book"
              : null,
            ebook_filename: this.newRaffleForm.ebook_enabled
              ? this.newRaffleForm.ebook_filename || null
              : null,
            ebook_file: this.newRaffleForm.ebook_enabled
              ? this.newRaffleForm.ebook_file || null
              : null,
            caixinha_enabled: !!this.newRaffleForm.caixinha_enabled,
            caixinha_type: this.newRaffleForm.caixinha_enabled
              ? this.newRaffleForm.caixinha_type || "caixa"
              : "caixa",
            roleta_enabled: !!this.newRaffleForm.roleta_enabled,
            raspadinha_enabled: !!this.newRaffleForm.raspadinha_enabled,
            prize_release_enabled: !!this.newRaffleForm.prize_release_enabled,
            prize_release_rules: this.buildPrizeReleaseRulesPayload(),
            flash_offer_enabled: !!this.newRaffleForm.flash_offer_enabled,
            flash_offers: this.buildFlashOffersPayload(),
            age_gate_enabled: !!this.newRaffleForm.age_gate_enabled,
            gallery_youtube_url: (this.newRaffleForm.gallery_youtube_url || "").trim() || null,
            display_flag_label: (this.newRaffleForm.display_flag_label || "").trim() || null,
            display_flag_color: (this.newRaffleForm.display_flag_label || "").trim()
              ? this.newRaffleForm.display_flag_color || "green"
              : null,
            landing_template:
              this.newRaffleForm.type === "AUTO"
                ? this.newRaffleForm.landing_template || "default"
                : "default",
            layout_style:
              this.newRaffleForm.type === "AUTO" &&
              this.newRaffleForm.landing_template === "premium"
                ? "wide"
                : "classic",
            ranking_show_quotas:
              !!this.newRaffleForm.show_ranking &&
              !!this.newRaffleForm.ranking_show_quotas,
            show_min_max_quotas: !!this.newRaffleForm.show_min_max_quotas,
            min_max_quotas_start_at: this.newRaffleForm.show_min_max_quotas
              ? this.newRaffleForm.min_max_quotas_start_at || null
              : null,
            min_max_quotas_end_at: this.newRaffleForm.show_min_max_quotas
              ? this.newRaffleForm.min_max_quotas_end_at || null
              : null,
            double_quotas_enabled: !!this.newRaffleForm.double_quotas_enabled,
            double_quotas_start_at: this.newRaffleForm.double_quotas_enabled
              ? this.newRaffleForm.double_quotas_start_at || null
              : null,
            double_quotas_end_at: this.newRaffleForm.double_quotas_enabled
              ? this.newRaffleForm.double_quotas_end_at || null
              : null,
            double_quotas_min_quotas: this.newRaffleForm.double_quotas_enabled
              ? Number(this.newRaffleForm.double_quotas_min_quotas) || 0
              : 0,
          };

          const response = await RafflesHttp.createRaffle(newRaffleUpdatedForm);
          this.$log.log("CAMPANHAS", "CRIAR", `Usuário criou a campanha "${this.newRaffleForm.name}" com ${this.newRaffleForm.qnt_quotas} cotas ao preço de ${this.newRaffleForm.quota_price} cada`);
          this.showToast();

          if (
            (this.user && this.user.system_wallet) ||
            response.data.status === "ACTIVE" ||
            response.data.system_wallet === true
          ) {
            if (this.user && this.user.role === "ADMIN") {
              this.$router.push("/");
            } else {
              this.$router.push("/raffles");
            }
          } else {
            this.$router.push(`pay/${response.data.slug}`);
          }
        } else {
          this.loading = false;
          return;
        }
      } catch (error) {
        this.loading = false;
        console.error("Erro ao criar campanha:", error);
        // AxiosConfig rejeita com body achatado (error.response some).
        const raw =
          typeof error === "string"
            ? error
            : error?.error ||
              error?.message ||
              error?.response?.data?.error ||
              error?.response?.data?.message ||
              "";
        const isTimeout =
          error?.code === "ECONNABORTED" ||
          /timeout/i.test(String(raw)) ||
          /timeout/i.test(String(error?.message || ""));
        const errorMsg = isTimeout
          ? "A criação demorou demais. Abra Minhas rifas — a campanha pode já ter sido criada. Se não estiver, tente de novo."
          : raw ||
            "Ocorreu um erro ao criar a campanha. Tente novamente!";
        this.$toast.add({
          severity: "error",
          summary: "Erro na criação",
          detail: errorMsg,
          life: 8000,
        });
      }
    },
    async updateRaffle() {
      try {
        if (this.validateAllFields()) {
          const user = this.$store.getters.user;

          const updatedRaffleForm = {
            ...this.newRaffleForm,
            id_user: user.id,
            quota_price: this.parseQuotaPrice(
              this.newRaffleForm.quota_price
            ).toString(),
            draw_date: this.getDateIfChecked(),
            ua: navigator.userAgent,
            minimum_purchase: this.parseNumberForStorage(
              this.newRaffleForm.minimum_purchase
            ),
            maximum_purchase: this.parseNumberForStorage(
              this.newRaffleForm.maximum_purchase
            ),
            ebook_enabled: !!this.newRaffleForm.ebook_enabled,
            ebook_title: this.newRaffleForm.ebook_enabled
              ? this.newRaffleForm.ebook_title || "E-book"
              : null,
            ebook_filename: this.newRaffleForm.ebook_enabled
              ? this.newRaffleForm.ebook_filename || null
              : null,
            ebook_file: this.newRaffleForm.ebook_enabled
              ? this.newRaffleForm.ebook_file || null
              : null,
            caixinha_enabled: !!this.newRaffleForm.caixinha_enabled,
            caixinha_type: this.newRaffleForm.caixinha_enabled
              ? this.newRaffleForm.caixinha_type || "caixa"
              : "caixa",
            roleta_enabled: !!this.newRaffleForm.roleta_enabled,
            raspadinha_enabled: !!this.newRaffleForm.raspadinha_enabled,
            prize_release_enabled: !!this.newRaffleForm.prize_release_enabled,
            prize_release_rules: this.buildPrizeReleaseRulesPayload(),
            flash_offer_enabled: !!this.newRaffleForm.flash_offer_enabled,
            flash_offers: this.buildFlashOffersPayload(),
            age_gate_enabled: !!this.newRaffleForm.age_gate_enabled,
            gallery_youtube_url: (this.newRaffleForm.gallery_youtube_url || "").trim() || null,
            display_flag_label: (this.newRaffleForm.display_flag_label || "").trim() || null,
            display_flag_color: (this.newRaffleForm.display_flag_label || "").trim()
              ? this.newRaffleForm.display_flag_color || "green"
              : null,
            landing_template:
              this.newRaffleForm.type === "AUTO"
                ? this.newRaffleForm.landing_template || "default"
                : "default",
            layout_style:
              this.newRaffleForm.type === "AUTO" &&
              this.newRaffleForm.landing_template === "premium"
                ? "wide"
                : "classic",
            ranking_show_quotas:
              !!this.newRaffleForm.show_ranking &&
              !!this.newRaffleForm.ranking_show_quotas,
            show_min_max_quotas: !!this.newRaffleForm.show_min_max_quotas,
            min_max_quotas_start_at: this.newRaffleForm.show_min_max_quotas
              ? this.newRaffleForm.min_max_quotas_start_at || null
              : null,
            min_max_quotas_end_at: this.newRaffleForm.show_min_max_quotas
              ? this.newRaffleForm.min_max_quotas_end_at || null
              : null,
            double_quotas_enabled: !!this.newRaffleForm.double_quotas_enabled,
            double_quotas_start_at: this.newRaffleForm.double_quotas_enabled
              ? this.newRaffleForm.double_quotas_start_at || null
              : null,
            double_quotas_end_at: this.newRaffleForm.double_quotas_enabled
              ? this.newRaffleForm.double_quotas_end_at || null
              : null,
            double_quotas_min_quotas: this.newRaffleForm.double_quotas_enabled
              ? Number(this.newRaffleForm.double_quotas_min_quotas) || 0
              : 0,
          };

          if (this.newRaffleForm.qnt_quotas > 3000) {
            delete updatedRaffleForm.quotas;
          }

          await RafflesHttp.updateRaffle(
            this.newRaffleForm.id,
            updatedRaffleForm
          );
          this.$log.log("CAMPANHAS", "EDITAR", `Usuário editou a campanha "${this.newRaffleForm.name}"`);
          this.showToast("success", "Sucesso!", "Sua campanha foi atualizada.");
          if (this.user && this.user.role === "ADMIN") {
            this.$router.push("/");
          } else {
            this.$router.push("/raffles");
          }
        } else {
          this.loading = false;
          return;
        }
      } catch (error) {
        this.loading = false;
        console.error("Erro ao atualizar campanha:", error);
        const errorMsg =
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Ocorreu um erro ao atualizar a campanha. Tente novamente!";
        this.$toast.add({
          severity: "error",
          summary: "Erro na atualização",
          detail: errorMsg,
          life: 5000,
        });
      }
    },
    submitRaffle() {
      this.loading = true;
      if (this.$route.name == RouteName.EditRaffle) {
        this.updateRaffle();
      } else {
        this.createRaffle();
      }
    },
    async reportErrorToSupport() {
      if (this.cooldownRemaining > 0) return;

      const payload = {
        ...this.newRaffleForm,
        quota_price: this.newRaffleForm.quota_price ? this.parseQuotaPrice(this.newRaffleForm.quota_price).toString() : "0",
        minimum_purchase: this.parseNumberForStorage(this.newRaffleForm.minimum_purchase),
        maximum_purchase: this.parseNumberForStorage(this.newRaffleForm.maximum_purchase),
      };

      this.reportingError = true;
      try {
        await RafflesHttp.reportError(payload);
        this.$toast.add({
          severity: "success",
          summary: "Sucesso!",
          detail: "Erro reportado com sucesso. Nossa equipe analisará o caso.",
          life: 4000,
        });
      } catch (err) {
        this.$toast.add({
          severity: "error",
          summary: "Ops...",
          detail: "Não foi possível reportar o erro no momento.",
          life: 3000,
        });
      } finally {
        this.reportingError = false;
        this.startCooldown();
      }
    },
    startCooldown() {
      this.cooldownRemaining = 30;
      const interval = setInterval(() => {
        this.cooldownRemaining--;
        if (this.cooldownRemaining <= 0) {
          clearInterval(interval);
        }
      }, 1000);
    },
    parseQuotaPrice(price) {
      let numericValue = price.replace(/[^\d,]+/g, "");

      numericValue = numericValue.replace(",", ".");

      return parseFloat(numericValue);
    },
    async generateAiCaption() {
      const brief = (this.aiCaptionBrief || "").trim();
      if (brief.length < 8) {
        this.$toast?.add?.({
          severity: "warn",
          summary: "Quase lá",
          detail: "Descreva um pouco mais a sua rifa pra IA gerar a legenda.",
          life: 3000,
        });
        return;
      }
      this.generatingCaption = true;
      this.aiCaptionHint = "";
      try {
        let quotaPrice = 0;
        try {
          quotaPrice = this.parseQuotaPrice(this.newRaffleForm.quota_price || "0") || 0;
        } catch (e) {
          quotaPrice = 0;
        }
        const res = await RafflesHttp.generateCaption({
          brief,
          campaign_name: this.newRaffleForm.name || "",
          quota_price: quotaPrice > 0 ? quotaPrice : null,
          qnt_quotas: this.newRaffleForm.qnt_quotas || null,
        });
        const caption = res?.data?.caption || "";
        if (!caption) {
          throw new Error("Legenda vazia");
        }
        this.newRaffleForm.description = caption;
        this.editorKey += 1;
        if (res?.data?.warning) {
          this.aiCaptionHint = res.data.warning;
        } else {
          this.aiCaptionHint = "Legenda gerada! Você pode editar no campo abaixo.";
        }
        this.$toast?.add?.({
          severity: "success",
          summary: "Legenda pronta",
          detail: "Descrição preenchida. Revise e ajuste se quiser.",
          life: 3000,
        });
      } catch (e) {
        console.error(e);
        this.$toast?.add?.({
          severity: "error",
          summary: "Erro",
          detail: e?.response?.data?.error || "Não foi possível gerar a legenda.",
          life: 3500,
        });
      } finally {
        this.generatingCaption = false;
      }
    },
    getDateIfChecked() {
      if (this.newRaffleForm.hasDate) {
        return this.newRaffleForm.draw_date;
      } else return null;
    },
    toDatetimeLocal(value) {
      if (!value) return "";
      const raw = String(value).replace(" ", "T");
      if (raw.length >= 16) return raw.slice(0, 16);
      return raw;
    },
    showToast(
      message = "success",
      summary = "Sucesso!",
      detail = "Sua campanha foi criada e aguarda pagamento."
    ) {
      this.$toast.add({
        severity: message,
        summary: summary,
        detail: detail,
        life: 3000,
      });
    },
    async getRaffle() {
      this.loading = true;
      try {
        const raffle = await RafflesHttp.getRaffle(this.$route.params.slug);
        this.newRaffleForm = { ...raffle.data };

        this.newRaffleForm.quota_price = parseFloat(
          this.newRaffleForm.quota_price
        )
          .toFixed(2)
          .replace(".", ",");

        if (raffle.data.draw_date != null) {
          this.newRaffleForm.draw_date = this.toDatetimeLocal(
            raffle.data.draw_date
          );
          this.newRaffleForm.hasDate = true;
        }

        this.newRaffleForm.ranking_start_at = this.toDatetimeLocal(
          raffle.data.ranking_start_at
        );
        this.newRaffleForm.ranking_end_at = this.toDatetimeLocal(
          raffle.data.ranking_end_at
        );
        this.newRaffleForm.ranking_prize_1 =
          raffle.data.ranking_prize_1 || "";
        this.newRaffleForm.ranking_prize_2 =
          raffle.data.ranking_prize_2 || "";
        this.newRaffleForm.ranking_prize_3 =
          raffle.data.ranking_prize_3 || "";
        this.newRaffleForm.ranking_show_quotas =
          raffle.data.ranking_show_quotas !== false &&
          raffle.data.ranking_show_quotas !== 0;

        this.newRaffleForm.show_min_max_quotas = !!raffle.data.show_min_max_quotas;
        this.newRaffleForm.min_max_quotas_start_at = this.toDatetimeLocal(
          raffle.data.min_max_quotas_start_at
        );
        this.newRaffleForm.min_max_quotas_end_at = this.toDatetimeLocal(
          raffle.data.min_max_quotas_end_at
        );

        this.newRaffleForm.double_quotas_enabled = !!raffle.data.double_quotas_enabled;
        this.newRaffleForm.double_quotas_start_at = this.toDatetimeLocal(
          raffle.data.double_quotas_start_at
        );
        this.newRaffleForm.double_quotas_end_at = this.toDatetimeLocal(
          raffle.data.double_quotas_end_at
        );
        this.newRaffleForm.double_quotas_min_quotas = raffle.data.double_quotas_min_quotas || 0;

        this.newRaffleForm.ebook_enabled = !!raffle.data.ebook_enabled;
        this.newRaffleForm.ebook_title = raffle.data.ebook_title || "";
        this.newRaffleForm.ebook_filename = raffle.data.ebook_filename || "";
        this.newRaffleForm.ebook_file = null;
        this.newRaffleForm.caixinha_enabled = !!raffle.data.caixinha_enabled;
        this.newRaffleForm.caixinha_type = raffle.data.caixinha_type || "caixa";
        this.newRaffleForm.caixinha_quotas = raffle.data.caixinha_quotas || [];
        this.newRaffleForm.roleta_enabled = !!raffle.data.roleta_enabled;
        this.newRaffleForm.roleta_quotas = raffle.data.roleta_quotas || [];
        this.newRaffleForm.raspadinha_enabled = !!raffle.data.raspadinha_enabled;
        this.newRaffleForm.raspadinha_quotas = raffle.data.raspadinha_quotas || [];
        this.newRaffleForm.flash_offer_enabled = !!raffle.data.flash_offer_enabled;
        this.newRaffleForm.flash_offers =
          Array.isArray(raffle.data.flash_offers) && raffle.data.flash_offers.length
            ? raffle.data.flash_offers.map((o) => ({
                title: o.title || "",
                subtitle: o.subtitle || "",
                badge_label: o.badge_label || "Oferta Relâmpago",
                extra_quotas: o.extra_quotas || 10,
                price:
                  o.price != null
                    ? String(o.price).replace(".", ",")
                    : "9,90",
                is_active: o.is_active !== false,
              }))
            : [
                {
                  title: "",
                  subtitle: "",
                  badge_label: "Oferta Relâmpago",
                  extra_quotas: 10,
                  price: "9,90",
                  is_active: true,
                },
              ];
        this.newRaffleForm.awarded_quotas = raffle.data.awarded_quotas || [];
        this.newRaffleForm.prize_release_enabled = !!raffle.data.prize_release_enabled;
        this.newRaffleForm.prize_release_rules = Array.isArray(
          raffle.data.prize_release_rules
        )
          ? raffle.data.prize_release_rules.map((r) => ({
              pct: Number(r.pct) || 0,
              qty: Number(r.qty) || 0,
            }))
          : [];
        this.newRaffleForm.prize_release_blocked = raffle.data.prize_release_blocked || 0;
        this.newRaffleForm.prize_release_released = raffle.data.prize_release_released || 0;
        this.newRaffleForm.prize_release_sold_pct = raffle.data.prize_release_sold_pct || 0;
        this.newRaffleForm.gallery_youtube_url =
          raffle.data.gallery_youtube_url || "";
        this.newRaffleForm.display_flag_label =
          raffle.data.display_flag_label || "";
        this.newRaffleForm.display_flag_color =
          raffle.data.display_flag_color || "green";
        this.newRaffleForm.landing_template =
          raffle.data.landing_template || "default";
        this.newRaffleForm.layout_style =
          raffle.data.layout_style || "classic";
        this.newRaffleForm.age_gate_enabled = !!raffle.data.age_gate_enabled;

        this.editorKey += 1;
      } catch (error) {
        console.error("Erro ao buscar a campanha:", error);
      } finally {
        this.loading = false;
      }
    },
    validateAllFields() {
      let isValid = true;

      if (this.newRaffleForm.name.length >= 50) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção!",
          detail: "O título da campanha não pode ter mais de 50 caracteres.",
          life: 6000,
        });
        isValid = false;
      }

      if (this.newRaffleForm.description.length >= 5000) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção!",
          detail:
            "A descrição da campanha não pode ter mais de 5000 caracteres.",
          life: 6000,
        });
        isValid = false;
      }

      if (
        this.newRaffleForm.name.trim() === "" ||
        this.newRaffleForm.type.trim() === "" ||
        this.newRaffleForm.qnt_quotas == null ||
        this.parseNumberForStorage(this.newRaffleForm.minimum_purchase) ==
          null ||
        this.parseNumberForStorage(this.newRaffleForm.maximum_purchase) ==
          null ||
        this.newRaffleForm.quota_price.trim() === "" ||
        this.newRaffleForm.phone.trim() === "" ||
        this.newRaffleForm.payment_time.trim() === ""
      ) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção!",
          detail: "Verifique todos os campos obrigatórios e tente novamente.",
          life: 3000,
        });
        isValid = false;
      }

      if (
        this.parseNumberForStorage(this.newRaffleForm.minimum_purchase) >
        this.parseNumberForStorage(this.newRaffleForm.maximum_purchase)
      ) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção!",
          detail:
            "A quantidade mínima de cotas por compra não pode ser maior que a quantidade máxima de cotas por compra. Verifique os respectivos campos e tente novamente.",
          life: 6000,
        });
        isValid = false;
      }

      if (this.parseQuotaPrice(this.newRaffleForm.quota_price) == 0) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção!",
          detail: "O valor da cota não pode ser R$ 0,00.",
          life: 6000,
        });
        isValid = false;
      }

      if (this.newRaffleForm.flash_offer_enabled) {
        const offers = this.buildFlashOffersPayload();
        if (offers.length === 0) {
          this.$toast.add({
            severity: "warn",
            summary: "Atenção!",
            detail:
              "Configure pelo menos 1 Oferta Relâmpago com título, cotas extras e preço.",
            life: 6000,
          });
          isValid = false;
        } else if (offers.some((o) => o.price <= 0)) {
          this.$toast.add({
            severity: "warn",
            summary: "Atenção!",
            detail: "O preço da Oferta Relâmpago deve ser maior que R$ 0,00.",
            life: 6000,
          });
          isValid = false;
        }
      }

      if (this.newRaffleForm.awards.length === 0) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção!",
          detail: "Adicione no mínimo um prêmio à campanha e tente novamente.",
          life: 6000,
        });
        isValid = false;
      }

      if (this.newRaffleForm.ebook_enabled) {
        const isNew = this.$route.name == RouteName.NewRaffle;
        const hasExistingFile = !!(this.newRaffleForm.ebook_filename && !isNew);
        const hasNewFile = !!this.newRaffleForm.ebook_file;
        if (!hasNewFile && !hasExistingFile) {
          this.$toast.add({
            severity: "warn",
            summary: "Atenção!",
            detail: "Envie o PDF do e-book ou desative o produto digital.",
            life: 5000,
          });
          isValid = false;
        }
      }

      if (
        this.$route.name == RouteName.NewRaffle &&
        this.acceptTerms === false
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Houve um erro!",
          detail:
            "Você precisa aceitar os termos de uso e a política de privacidade para continuar.",
          life: 3000,
        });
        return;
      }

      return isValid;
    },
    handleLoading(state) {
      this.loading = state;
    },
    onEbookFileSelected(event) {
      const file = event?.target?.files?.[0];
      if (!file) {
        this.newRaffleForm.ebook_file = null;
        return;
      }
      if (file.type !== "application/pdf" && !String(file.name).toLowerCase().endsWith(".pdf")) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção!",
          detail: "Envie apenas arquivo PDF.",
          life: 4000,
        });
        event.target.value = "";
        return;
      }
      if (file.size > 25 * 1024 * 1024) {
        this.$toast.add({
          severity: "warn",
          summary: "Atenção!",
          detail: "O PDF deve ter no máximo 25 MB.",
          life: 4000,
        });
        event.target.value = "";
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.newRaffleForm.ebook_file = reader.result;
        this.newRaffleForm.ebook_filename = file.name;
      };
      reader.onerror = () => {
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Não foi possível ler o PDF.",
          life: 3000,
        });
      };
      reader.readAsDataURL(file);
    },
    formatNumberInput(value, fieldName) {
      const numericString = String(value).replace(/\D/g, "");

      if (!numericString) {
        this.newRaffleForm[fieldName] = null;
        return null;
      }

      const numericValue = parseInt(numericString, 10);

      const formattedValue = numericValue.toLocaleString("pt-BR", {
        maximumFractionDigits: 0,
      });

      this.newRaffleForm[fieldName] = formattedValue;

      return formattedValue;
    },
  },
  async mounted() {
    // Fetch user data to check for system_wallet
    this.user = this.$store.getters.user;

    new MaskInput(".maska");
    if (this.$route.name == RouteName.EditRaffle) {
      this.getRaffle();
    } else if (this.user && this.user.system_wallet) {
      this.systemWalletWarningDialog = true;
    }
  },
  watch: {
    newRaffleForm: {
      handler(newForm) {
        if (newForm.qnt_quotas > 3000) {
          this.newRaffleForm.type = "AUTO";
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
.campaing-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.input-label {
  margin: 0;
  padding: 0;
  width: 100%;
}

.ranking-window-fields,
.ranking-prize-fields {
  width: 100%;
  max-width: 100%;

  .input-group {
    min-width: 0;
  }

  .form-control {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }
}

.new-campaign-title {
  font-size: 28px;
  margin-bottom: 24px;
  display: flex;
  color: #0f172a;
  align-items: center;
  gap: 8px;
}

.ticket-icon {
  font-size: 24px;
}

.submit-button {
  background-color: #22c55e;
  color: white;
  display: flex;
  min-height: 40px;
  height: auto;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 1.2;
  white-space: nowrap;
  padding-left: 0.9rem;
  padding-right: 0.9rem;

  .btn-icon {
    font-size: 1.4em;
  }

  &:hover {
    transform: scale(1.04);
    background-color: #169444;
    color: white;
  }
}

.cancel-button {
  background-color: #e0e0e0;
  color: #0f172a;
  display: flex;
  min-height: 40px;
  height: auto;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 1.2;
  white-space: nowrap;
  padding-left: 0.9rem;
  padding-right: 0.9rem;

  .btn-icon {
    font-size: 1.4em;
  }

  &:hover {
    transform: scale(1.04);
    background-color: #d6d6d6;
    color: #0f172a;
  }
}

@media (max-width: 576px) {
  .submit-button,
  .cancel-button {
    white-space: normal;
    text-align: center;
    flex: 1 1 auto;
    max-width: 48%;
    font-size: 0.82rem;
    padding: 0.55rem 0.5rem;
  }

  .submit-button .ticket-icon {
    font-size: 18px;
  }
}

.taxes-button {
  color: #0f172a;
  border: 1px solid #0f172a !important;
  display: flex;
  height: 30px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;

  .btn-icon {
    font-size: 1.4em;
  }

  &:hover {
    background-color: #eeeeee;
    color: #0f172a;
  }
}

.option-button {
  background-color: #ffffff;
  border: 1px solid #d2d6da !important;
  color: #0f172a;
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 6px;

  .material-icons {
    font-size: 1.2em;
  }

  &:hover {
    background-color: #f8f9fa;
  }

  &:disabled {
    opacity: 0.55;
  }
}

.form-switch .form-check-input {
  border-color: #169444;

  &:checked {
    background-color: #169444;
  }
  &:checked::after {
    border-color: #cdd3d9;
    box-shadow: none;
  }
  &:active::after {
    transition: box-shadow 0.1s ease-in-out;
    box-shadow: none;
  }
  &:checked:active::after {
    transition: box-shadow 0.1s ease-in-out;
    box-shadow: none;
  }
}

.switch-field {
  display: flex;
  align-items: center;
  gap: 14px;

  label {
    margin: 0;
  }
}

.check-field {
  border-radius: 6px;
  border: 1px solid #d2d6da;
  padding: 14px;
}

.total-value {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  width: 100%;
  padding: 12px 20px;
  min-height: 100px;
  border: 1px solid #d2d6da;
  color: #0f172a;
  border-radius: 14px;

  &-title {
    font-size: 22px;
    margin-bottom: 8px;
    font-weight: bolder;
  }

  &-values {
    font-size: 16px;
    width: 100%;
    display: flex;
    color: #7b809a;
    justify-content: space-between;
  }
}

.feature-toggles-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  width: 100%;
}

@media (max-width: 1100px) {
  .feature-toggles-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 650px) {
  .feature-toggles-grid {
    grid-template-columns: 1fr;
  }
}

.taxes-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.negative {
  color: #dc2626;
}

.positive {
  color: #1ba54e;
}

@media (max-width: 1000px) {
  .three-fields,
  .ranking-window-fields,
  .ranking-prize-fields {
    flex-direction: column !important;
    gap: 16px !important;
  }

  .ranking-window-fields > div,
  .ranking-prize-fields > div {
    width: 100% !important;
    flex: none !important;
    max-width: 100% !important;
  }

  .taxes-field {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 14px;
  }

  .taxes-button {
    width: 100%;
  }
}

.terms {
  display: flex;
  flex-direction: column;
  gap: 8px;

  a {
    color: #169444;
    text-decoration: none;
  }

  p {
    font-size: 14px;
    margin-top: 20px;
  }
}

.terms-button {
  color: #169444;
  cursor: pointer;
}

.bg-premium-diamond {
  background: linear-gradient(135deg, #141414 0%, #2d2d2d 100%) !important;
  border: 1px solid rgba(255, 215, 0, 0.4);
  color: #fff !important;
}

.text-gold {
  color: #ffd700 !important;
}

.premium-text-gold {
  color: #ffd700;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.premium-text {
  color: #ffffff;
  font-weight: 800;
  margin-right: 4px;
}

.display-flag-preview {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  width: fit-content;
  max-width: 100%;

  &.flag-green {
    background: #2f9e5f;
  }
  &.flag-red {
    background: #c62828;
  }
  &.flag-orange {
    background: #e67e22;
  }
  &.flag-black {
    background: #1a1a1a;
  }
  &.flag-purple {
    background: #6c3483;
  }
  &.flag-blue {
    background: #1a5276;
  }
}

.ai-caption-box {
  background: linear-gradient(180deg, rgba(94, 41, 176, 0.04), transparent 70%);
  border-radius: 12px !important;
  padding: 1rem 1.1rem !important;
}

.ai-caption-input {
  padding: 0.85rem 1rem !important;
  line-height: 1.45 !important;
  min-height: 96px;
  border-radius: 10px !important;
  resize: vertical;
  box-sizing: border-box;
}

.ai-caption-btn {
  white-space: nowrap;
}

.ai-caption-hint {
  flex: 1 1 160px;
  line-height: 1.35;
}

@media (max-width: 576px) {
  .ai-caption-box {
    padding: 0.85rem 0.9rem !important;
  }

  .ai-caption-input {
    padding: 0.8rem 0.9rem !important;
    font-size: 0.92rem !important;
    min-height: 110px;
  }

  .ai-caption-actions {
    flex-direction: column;
    align-items: stretch !important;
  }

  .ai-caption-btn {
    width: 100%;
  }

  .ai-caption-hint {
    flex: none;
    width: 100%;
  }
}

/* Editor description: breathing room on mobile */
.default-bordered-input :deep(.ql-editor) {
  padding: 0.9rem 1rem !important;
}

@media (max-width: 576px) {
  .default-bordered-input :deep(.ql-editor) {
    padding: 0.85rem 0.9rem !important;
    min-height: 220px;
  }

  .default-bordered-input :deep(.ql-toolbar) {
    padding: 0.45rem 0.35rem !important;
  }
}

.prize-game-field-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.prize-game-field-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
}

.prize-game-option-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.prize-game-btn-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
}
</style>
